module.exports = __webpack_public_path__ + "static/1298392392-exit.198a4038.jpg";